import { getAuthHeaders } from "../auth";
import {
  NOTIFICATIONS_LIST,
  CLEAR_NOTIFICATIONS,
  MARKASREAD_NOTIFICATIONS,
} from "../constants";
export const getNotficationServiceConfig = (queryParams) => {
  return {
    url: `${NOTIFICATIONS_LIST}?${queryParams}`,
    options: {
      method: "GET",
      headers: getAuthHeaders(),
    },
  };
};
export const clearNotificationsServiceConfig = (selectedRecords) => {
  const payload = {
    NotificationIDs: selectedRecords.join(","),
  };
  return {
    url: CLEAR_NOTIFICATIONS,
    options: {
      method: "DELETE",
      headers: getAuthHeaders(),
      body: JSON.stringify(payload),
    },
  };
};

export const updateNotificationStatusServiceConfig = (records) => {
  const payload = {
    NotificationIDs: records.join(","),
  };
  return {
    url: MARKASREAD_NOTIFICATIONS,
    options: {
      method: "PUT",
      headers: getAuthHeaders(),
      body: JSON.stringify(payload),
    },
  };
};
